import React, {useState} from "react"
import { Link } from 'react-router-dom'
import { login } from '../services/login/login'
import { userLogin } from '../Store/Actions/userLogin'
import { useDispatch } from "react-redux"
import { TermsAndConditions } from "../App/Components/TermsAndConditions"
import { updateConsent } from "../services/login/updateConsent"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content' 
import { LoginHeader } from '../App/Components/LoginHeader'
import { GoogleButton } from "../App/Components/GoogleButton"
import { FacebookButton } from '../App/Components/FacebookButton'
import { register } from '../services/login/register'
import { useGetQueryParam } from '../hooks/useGetQueryParam'
const MySwal = withReactContent(Swal)

function Login() {
  const isKriator = useGetQueryParam().get('kriator') === 'true'
  const dispatch = useDispatch()
  const [loginData, setLoginData] = useState({
    mail: '',
    password: ''
  })
  const [showToc ,setShowToc] = useState(false)
  const [loginToken, setLoginToken] = useState('')

  
  const updateLoginData = ({token, consentimiento}) => {
    if (consentimiento === 'n') {
      setLoginToken(token)
      setShowToc(true)
    } else {
      dispatch(userLogin(token))
      window.localStorage.setItem('improve-bot-token', token)
    }
  }

  const handleLoginDataUpdate = (event) => {
    setLoginData({ ...loginData, [event.target.name]: event.target.value })
  }

  const handleSignIn = async (event) => {
    if (event.preventDefault) {
      event.preventDefault()
    }

    let loginMethodData = loginData 
    if (event.tokenId) {
      loginMethodData = {tokenGoogle: event.tokenId}
    } else if (event.accessToken) {
      loginMethodData = {
        tokenFacebook: event.accessToken,
        mail: event.email
      }
    }

    try {
      const response = await login(loginMethodData)
      if (response.request.status === 202) {
        MySwal.fire({
          icon: 'warning',
          title: "Cuenta inactiva",
          text: 'Tu cuenta aún no está activa, pronto un ejecutivo se comunicará contigo'
        })
        return 
      }
      // const { token, consentimiento } = response.data
      updateLoginData(response.data)
      

    } catch (error) {
      const status = error.response ? error.response.status : null 
      let html = error.message
      if (status === 500) {
        html = 'Error inesperado'
      } else if (status === 429) {
        html = 'Tu cuenta fue bloqueada, ponte en contacto con el equipo de soporte para reactivarla'
      } else if (status === 401) {
        html = 'Datos no validos'
      } else if (status === 502 && (event.tokenId || event.accessToken)) {
        await register({...loginMethodData, isKriator})
        Swal.fire({
          icon: 'success',
          title: 'Nos emociona saber que diste este primer paso!',
          html: (
            `<div>
              <p>En unos minutos te llegará un correo de bienvenida y los siguientes pasos que deberás tomar para crear tu BOT.</p>
              <p>
                <b>Nota:</b> No olvides revisar tus carpetas para encontrar este correo.
              </p>
            </div>`
          ), 
          confirmButtonText: 'Volver',
        })
        return
        // const response = await login(event.tokenId ? {tokenGoogle: event.tokenId} : loginData)
        // updateLoginData(response.data)
      }

      MySwal.fire({
        icon: "error",
        title: "Error",
        html
      })
    } 
  }

  const onAceptTerms = async () => {
    try {
      await updateConsent(loginToken)
      dispatch(userLogin(loginToken))
      window.localStorage.setItem('improve-bot-token', loginToken)
    } catch (error) {
      console.error(error)
    }
  }

  if (showToc)  {
    return (
      <TermsAndConditions 
        handleAceptTerms={onAceptTerms}
      />
    )
  }

  return (
    <section className="login">
      <LoginHeader />
      <div className="login__formContainer">
        <form
          onSubmit={handleSignIn}
          className="login__form"
        >
          <div className="login__form__inputContainer">
            <h2 className="login__form__inputTitle">
          Ingresa tu email
            </h2>
            <input
              required
              className="login__form__input"
              type='email'
              name='mail'
              onChange={handleLoginDataUpdate}
              value={loginData.mail}
            />
          </div>
          <div className="login__form__inputContainer">
            <h2 className="login__form__inputTitle">
            Ingresa tu contraseña
            </h2>
            <input
              required
              className="login__form__input"
              type='password'
              name='password'
              value={loginData.password}
              onChange={handleLoginDataUpdate}
            />
          </div >
          <button className="krino__button login__form__button">
            Iniciar Sesión
          </button>
          <hr />
          <div className="logginGoogleButton">
            <GoogleButton
              text='Continuar con Google'
              onSuccess={handleSignIn}
            />
          </div>
          <div className="logginGoogleButton">
            <FacebookButton
              onSuccess={handleSignIn}
            />
          </div>
          
          <div className="loginLink__container">
            <Link to="/login/old" className="loginLink loginLink--signUp">
            Ir al login antiguo
            </Link>
            <br />
            <Link
              to={!isKriator ? '/sign-up' : '/sign-up?kriator=true'}
              className="loginLink loginLink--signUp"
            >
              <span>
                {'¿No tienes una cuenta? '}
              </span>
              Regístrate
            </Link>
            <br />
            <Link to="/reset-password" className="loginLink loginLink--resetPassword">
              ¿Olvidaste tu contraseña?
            </Link>
            <Link to="/reset-password" className="loginLink loginLink--help">
            ¿Necesitas ayuda para iniciar?
            </Link>
          </div>
          
          <small>Powered by Krino©</small>
        </form>
      </div>

    </section>
  )
}

export default Login
